import DataSourceDataTableReadDto from "./DataSourceDataTableReadDto";
import DataTableReadDto from "./DataTableReadDto";

class DataTableRelationDto {

    Id: number;
    LinkedTable: DataTableReadDto;
    Type: number;
    Source: number;

    constructor(id: number, linkedTable: DataTableReadDto, type: number, source: number) {
        this.Id = id;
        this.LinkedTable = linkedTable;
        this.Type = type;
        this.Source = source;
    }

    get SourceLabel(): string {
        if (this.LinkedTable instanceof DataSourceDataTableReadDto) {
            return this.LinkedTable.TableReferenceLabel;
        };
        return "Unmanaged";
    }

    get TypeLabel(): string {
        switch (this.Type) {
            case 1:
                return "One to one";
            case 2:
                return "One to many";
            case 3:
                return "Many to many";
        }
        return "Unmanaged";
    }

    get JoinTypeLabel(): string {
        return "Inner";
    }

}

export default DataTableRelationDto;